import { useSyncExternalStore } from "react";

/** Tiny global UI state (command palette, shortcuts sheet, mobile nav, the Instagram reconnect dialog). */
type UiState = { palette: boolean; shortcuts: boolean; mobileNav: boolean; reconnect: boolean; moreSheet: boolean };
let state: UiState = { palette: false, shortcuts: false, mobileNav: false, reconnect: false, moreSheet: false };
const ls = new Set<() => void>();

export const ui = {
  get: () => state,
  set(patch: Partial<UiState>) {
    state = { ...state, ...patch };
    ls.forEach((l) => l());
  },
  subscribe(l: () => void) {
    ls.add(l);
    return () => ls.delete(l);
  },
};

export function useUi() {
  return useSyncExternalStore(ui.subscribe, ui.get, ui.get);
}
